module.exports = __webpack_public_path__ + "img/logan-hollowell.35d030d5.svg";